import { Button } from '@/components/ui/Button'
import { Icon } from '@/components/ui/Icon'
import styles from './Error.module.scss'

interface ErrorDisplayProps {
  title: string
  description: string
  onGoHome: () => void
}

export const ErrorDisplay = ({
  title,
  description,
  onGoHome,
}: ErrorDisplayProps) => (
  <div className={styles.container}>
    <div className={styles.content}>
      <Icon name="error" color="var(--color-error)" size={48} />
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.description}>{description}</p>
      <Button text="Go Home" variant="primary" onClick={onGoHome} />
    </div>
  </div>
)
